import React from 'react';

const LotterySvg = ({ width = "100px", height = "100px", color = "currentColor", className = "" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            // x="0px"
            // y="0px"
            viewBox="0 0 511.999 511.999"
            // xmlSpace="preserve"
            width={width}
            height={height}
            className={className}
            style={{ enableBackground: 'new 0 0 511.999 511.999' }}
            fill={color}
        >
            <g>
                <g>
                    <path
                        
                        d="M319.437,486.683l-6.2-106.699h-47.931l6.361,109.475c0.772,13.295,12.209,23.278,25.273,22.497 C310.132,511.19,320.204,499.875,319.437,486.683z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M398.141,103.704l-36.204-91.121C357.87,2.35,346.28-2.654,336.046,1.416c-10.233,4.065-15.233,15.657-11.167,25.891 L353.4,99.092l-47.807,16.67H288.93v-0.001c-0.08-0.134-0.161-0.269-0.243-0.402l-0.154,0.402 c-5.986,15.638-11.314,29.557-24.365,63.655h43.764v-23.778c0,0,38.461-12.047,78.244-25.745 C396.884,126.158,402.328,114.243,398.141,103.704z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M268.807,147.216l-8.002-14.555l7.114-12.939c1.059-1.926-0.337-4.292-2.538-4.292h-19.527 c-2.198,0-3.599,2.362-2.538,4.292l7.114,12.939l-8.032,14.608c-0.931,1.693-1.236,3.663-0.859,5.558l5.095,25.663 c-2.561-6.57-21.695-55.638-24.461-62.732h-21.752c-6.603,0-12.778,3.269-16.49,8.73l-29.957,44.073l-3.847-7.603 c-4.975-9.832-17.007-13.738-26.792-8.79c-9.284,4.701-14.114,16.265-8.558,27.246h80.039l7.506-11.044v11.044h44.495h17.193 l5.633-26.534C270.054,150.954,269.757,148.943,268.807,147.216z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M255.619,19.944c-22.821,0-41.322,18.5-41.322,41.322c0,22.86,18.564,41.322,41.322,41.322 c22.6,0,41.322-18.318,41.322-41.322C296.941,38.445,278.44,19.944,255.619,19.944z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M197.461,379.984l-6.201,106.699c-0.796,13.694,10.078,25.314,23.907,25.314c12.579,0,23.125-9.82,23.864-22.538 l6.361-109.475H197.461z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M388.625,279.388v8.243c2.091-0.492,3.752-1.661,3.752-3.876C392.377,281.726,390.84,280.432,388.625,279.388z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M381.242,264.13c0,1.784,1.599,2.891,3.937,3.875v-7.32C382.412,261.24,381.242,262.655,381.242,264.13z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M341.967,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068 c3.398,0,5.462-1.88,5.462-6.068v-16.082C347.429,262.2,345.366,260.319,341.967,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M307.44,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068c3.398,0,5.462-1.88,5.462-6.068 v-16.082C312.902,262.2,310.838,260.319,307.44,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M157.258,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068 c3.398,0,5.462-1.88,5.462-6.068v-16.082C162.719,262.2,160.656,260.319,157.258,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M191.785,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068 c3.398,0,5.462-1.88,5.462-6.068v-16.082C197.247,262.2,195.183,260.319,191.785,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M272.913,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.003,6.068,5.401,6.068 c3.398,0,5.462-1.88,5.462-6.068v-16.082C278.376,262.2,276.312,260.319,272.913,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M226.311,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068 c3.398,0,5.462-1.88,5.462-6.068v-16.082C231.774,262.2,229.71,260.319,226.311,260.319z"
                    />
                </g>
                <g>
                    <path
                        
                        d="M417.878,196.084H94.121c-8.743,0-15.831,7.087-15.831,15.831v134.46c0,8.743,7.087,15.832,15.831,15.832 h323.757c8.743,0,15.832-7.089,15.832-15.832v-134.46C433.71,203.171,426.62,196.084,417.878,196.084z M402.581,309.582 c0,5.78-4.694,10.474-10.474,10.474H119.892c-5.78,0-10.474-4.694-10.474-10.474v-103.719c0-5.78,4.694-10.474,10.474-10.474h272.215 c5.78,0,10.474,4.694,10.474,10.474v103.719z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default LotterySvg;
